/* eslint-disable no-console */
import { jsPDF } from 'jspdf';

import { Slide } from '../../components/SlideComponents/slide.types';
import { getImageDimensions } from './addImage';
import { parseRGB } from './utils';

const centerDimensions = (
  canvasWidth: number,
  canvasHeight: number,
  imageWidth: number,
  imageHeight: number,
) => {
  const canvasRatio = canvasWidth === 0 ? 1 : canvasHeight / canvasWidth;
  const imageRatio = imageWidth === 0 ? 1 : imageHeight / imageWidth;
  const centerHorizontally = imageRatio < canvasRatio;

  const resizedImageWidth = centerHorizontally ? canvasHeight / imageRatio : canvasWidth;
  const resizedImageHeight = centerHorizontally ? canvasHeight : canvasWidth * imageRatio;
  const x = centerHorizontally ? canvasWidth / 2 - resizedImageWidth / 2 : 0;
  const y = centerHorizontally ? 0 : canvasHeight / 2 - resizedImageHeight / 2;

  return { x, y, width: resizedImageWidth, height: resizedImageHeight };
};

export const addBackground = async (pdf: jsPDF, slide: Slide) => {
  try {
    if (slide.backgroundMedia?.fileMimeType === 'image/unsplash') {
      const originalImageDimensions = await getImageDimensions(
        slide.backgroundMedia?.fileId ?? '',
      );
      const imageDimensions = centerDimensions(
        slide.width,
        slide.height,
        originalImageDimensions.width,
        originalImageDimensions.height ?? 0,
      );
      pdf.addImage(
        slide.backgroundMedia?.fileId ?? '',
        '',
        imageDimensions.x,
        imageDimensions.y,
        imageDimensions.width,
        imageDimensions.height,

        undefined,
        'FAST',
      );
    } else {
      let color = '#F9F3EB'; // default color
      if (slide.backgroundMedia?.fileMimeType === 'image/color') {
        if (!slide.backgroundMedia?.fileId) return;
        color = slide.backgroundMedia.fileId;
      }
      pdf.saveGraphicsState();
      const rgb = parseRGB(color);
      if (rgb) {
        const [r, g, b] = rgb;
        pdf.setFillColor(r, g, b);
        pdf.rect(0, 0, slide.width, slide.height, 'F');
      }
      pdf.restoreGraphicsState();
    }

    pdf.saveGraphicsState();
    /*
      If brightness is from 0.5-1.0 interval, add a white rectangle with -0.5 + `brightness` opacity.
      Otherwise add a black rectangle with 0.5 - `brightness` opacity.
    */
    const fillColor = (slide.backgroundMedia?.brightness ?? 0.5) > 0.5 ? '1' : '0';
    const fillColorOpacity = Math.abs((slide.backgroundMedia?.brightness ?? 0.5) - 0.5);
    const newGState = pdf.GState({
      opacity: fillColorOpacity,
    });
    pdf.setGState(newGState);
    pdf.setFillColor(fillColor);
    pdf.rect(0, 0, slide.width, slide.height, 'F');
    pdf.restoreGraphicsState();
  } catch (err) {
    console.error('Background image could not be added');
    console.error(err);
  }
};
